import {
  SECTOR_PACK_IDS,
  answerGuardsSchema,
  sectorPackIdSchema,
  sectorPackSchema,
  type AnswerGuardsConfig,
  type SectorPack,
  type SectorPackId,
} from './schema.js'
import { financePack } from './packs/finance.js'
import { compliancePack } from './packs/compliance.js'
import { healthcarePack } from './packs/healthcare.js'
import { constructionPack } from './packs/construction.js'

/**
 * Sector-Pack-Registry (M4, EDIH-Vertrag §4): die vier Packs werden beim
 * Modul-Import gegen das Schema validiert — ein fehlerhaftes Pack faellt
 * sofort auf (fail-fast), statt erst zur Laufzeit still Regeln auszusetzen.
 */
const PACK_LIST: readonly SectorPack[] = [
  financePack,
  compliancePack,
  healthcarePack,
  constructionPack,
]

// Fail-fast: fehlerhafte Pack-Daten brechen den Import, nicht erst den Request.
for (const pack of PACK_LIST) {
  sectorPackSchema.parse(pack)
}

const PACKS_BY_ID: ReadonlyMap<SectorPackId, SectorPack> = new Map(
  PACK_LIST.map((pack) => [pack.id, pack]),
)

/** Liefert das Pack zur ID oder null, wenn die ID unbekannt ist. */
export function getSectorPack(id: string): SectorPack | null {
  const parsed = sectorPackIdSchema.safeParse(id)
  if (!parsed.success) return null
  return PACKS_BY_ID.get(parsed.data) ?? null
}

/** Alle registrierten Packs (Validierung beim Import bereits erfolgt). */
export function listSectorPacks(): SectorPack[] {
  return [...PACK_LIST]
}

/**
 * Validierungs-Helper: parst unbekannte Daten gegen das Pack-Schema.
 * Gibt das validierte Pack zurueck oder null bei Verstoss.
 */
export function validateSectorPack(data: unknown): SectorPack | null {
  const parsed = sectorPackSchema.safeParse(data)
  return parsed.success ? parsed.data : null
}

export { answerGuardsSchema, sectorPackIdSchema, sectorPackSchema, SECTOR_PACK_IDS }
export type { AnswerGuardsConfig, SectorPack, SectorPackId }
